import React, { useState, useEffect}  from 'react';
import { DataContext } from '../App';
import { Bar } from "react-chartjs-2";
import {
    LineElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
    PointElement
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement
);

ChartJS.register(annotationPlugin);

const {getPadding, average, min, max} = require('../utils.js');

function MonthlyFruitFlyTraffic(){
    const forecast = React.useContext(DataContext);
   
    const hours = ["3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12am", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm"]
    

    var availableMonths = forecast.premium.monthly_fruitfly_traffic.months

    var options = []
    for (let i = availableMonths.length -1; i >=0 ; i--) {
        options.push({value: i, text:availableMonths[i]})
    }

    const [selected1, setSelected1] = useState(options[0].value);
    const [selected2, setSelected2] = useState(options[options.length-1].value);

    const handleChange1 = event => {
        console.log(event.target.value);
        setSelected1(event.target.value);
    }
    const handleChange2 = event => {
        console.log(event.target.value);
        setSelected2(event.target.value);
    }

    var historicalHourlyFruitflyTraffic1 = forecast.premium.monthly_fruitfly_traffic.data[selected1];
    var historicalHourlyFruitflyTraffic2 = forecast.premium.monthly_fruitfly_traffic.data[selected2];

    const chartdata = {
        labels: hours.slice(2,historicalHourlyFruitflyTraffic1.length - 2),
        datasets: [{
            label: availableMonths[selected1],
            data: historicalHourlyFruitflyTraffic1.slice(2,historicalHourlyFruitflyTraffic2.length - 2),
            backgroundColor: '#282880',
            borderRadius: 10,
            borderSkipped: false
        },
        {
            label: availableMonths[selected2],
            data: historicalHourlyFruitflyTraffic2.slice(2,historicalHourlyFruitflyTraffic2.length - 2),
            backgroundColor: '#38cb88',
            borderRadius: 10,
            borderSkipped: false
        }    
    ]
    };
    
    const chartoptions = {
        scales: {
            y: {
                beginAtZero: true,
                max: max(historicalHourlyFruitflyTraffic1.concat(historicalHourlyFruitflyTraffic2)) + 1,
                min: -1,
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: false,
                }
            },
            x: {
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: true,
                    maxRotation: 45,
                    minRotation: 45
                }
            }
        },
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        plugins: {
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function(context) { return context.dataset.label}
                },
                backgroundColor: "#FFFFFF",
                bodyColor: "#000000",
                titleColor: "#000000",
                cornerRadius: 0,
                borderColor: "rgba(50 ,50, 50, 0.25)",
                borderWidth: 1
            },
            legend: {
                display: false
            },
            autocolors: false
        }
    };

    return(
        <div className="card-body">
            <div className="row">
                <div className="col-lg-8"></div>
                <div className="col-lg-2">
                    <select id="regionSelector" className="form-control form-control-sm" style={{borderColor:"#282880"}} value={selected1} onChange={handleChange1}>
                        {options.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div> 
                <div className="col-lg-2">
                    <select id="regionSelector" className="form-control form-control-sm" style={{borderColor:"#38cb88"}} value={selected2} onChange={handleChange2}>
                        {options.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div> 
            </div> 
            <div style={{height:"180px"}}>
                <Bar
                    data={chartdata}
                    options={chartoptions}
                />
            </div>
        </div>

    );

}

export default MonthlyFruitFlyTraffic;